import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  ProgressBar,
} from '@fluentui/react-components';

import { StatusPopoverItem, Status } from '@bingads-webui-campaign-react/status-popover';
import { useStyles } from '../../styles/status-section-styles';

export function StatusSection({
  details,
  i18n,
}) {
  const classes = useStyles();

  const denominator = details.length;
  const numerator = details.filter(item => item.status === Status.Active).length;
  const value = Math.max(0.05, numerator / denominator);

  const items = details.map(item => <StatusPopoverItem key={item.name} {...item} i18n={i18n} />);

  return (
    <div className={classNames('ba-diagnostic-card-status-section')}>
      <ProgressBar
        className={classNames('ba-diagnostic-progress-bar', classes.progressBar)}
        value={value}
        thickness="large"
        aria-label={i18n.getString(_TL_('Progress bar'))}
      />
      <div className={classNames('ba-diagnostic-card-status-list', classes.statusList)}>
        {items}
      </div>
    </div>
  );
}

StatusSection.propTypes = {
  details: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(Status)).isRequired,
    statusLabelMsg: PropTypes.string.isRequired,
  })).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
